export default "__VITE_ASSET__cd290260__"